import { LogsContextModel, LogsShowFilterType } from '@shared/models';
import { createContext, Dispatch } from 'react';

export const LogsReducerDefaultValues = {
  includeDeviceCommands: false,
  activeCommands: false,
  showFilter: LogsShowFilterType.CurrentPMZ,
} as LogsContextModel;

export enum LogsActionType {
  SetIncludeDeviceCommands = 'SetIncludeDeviceCommands',
  SetActiveCommands = 'SetActiveCommands',
  SetShowFilter = 'SetShowFilter',
}

type State = LogsContextModel;
type Action = {
  type: LogsActionType;
  payload: boolean | LogsShowFilterType;
};

export const logsReducer = (state: State, action: Action): State => {
  const { type, payload } = action;
  switch (type) {
    case LogsActionType.SetIncludeDeviceCommands:
      return {
        ...state,
        includeDeviceCommands: payload as boolean,
      };
    case LogsActionType.SetActiveCommands:
      return {
        ...state,
        activeCommands: payload as boolean,
      };
    case LogsActionType.SetShowFilter:
      return {
        ...state,
        showFilter: payload as LogsShowFilterType,
      };
    default:
      return state;
  }
};

export const LogsContext = createContext<{
  state?: State;
  dispatch?: Dispatch<Action>;
}>({});
